import React from 'react';
import PropTypes from 'prop-types';
import { trim, get } from 'lodash';
import { Group } from 'components/core/Page';
import { Card } from 'components/core/Card';
import { H2, Paragraph, Text } from 'components/core/Typography';
import { UnitPrice } from 'components/unit/UnitPrice';

import { getScarcityFlag } from 'utils/store/getScarcityFlag';

import './selectedUnitCard.scss';

export default function SelectedUnitCard({ unit }) {
	return (
		<Card className="selected-unit-card">
			<div className="divider">
				<H2
					className="selected-unit-card-header"
					size="medium"
				>
					Your storage unit
				</H2>
			</div>
			<Group>
				<Paragraph size="small">
					Unit type:
				</Paragraph>
				<Paragraph>
					{ unit.sizeText } <span className="unit-type">{unit.unitTypeText}</span>
				</Paragraph>
			</Group>

			{!!unit.amenitiesText &&
				<Group>
					<Paragraph size="small">
						Features:
					</Paragraph>
					<Paragraph>
						{unit.amenitiesText}
					</Paragraph>
				</Group>
			}

			{!!unit.promotion &&
				<Group>
					<Paragraph size="small">
						Specials:
					</Paragraph>
					<Paragraph
						size="small"
						color="green"
					>
						{trim(unit.promotion)}
					</Paragraph>
				</Group>
			}

			<div className="selected-unit-price">
				<Text last size="small">
					Monthly rent:
				</Text>
				<UnitPrice
					className="time-boxed-unit-price"
					price={unit.price.text}
					regularPrice={(
						get(unit, 'regularPrice.value') !== get(unit, 'price.value') ?
							get(unit, 'regularPrice.text', null) : null
					)}
					unitQuantity={unit.quantity}
					isScarce={getScarcityFlag([unit])}
					linkedPrice={false}
					size="medium"
					showPeriod
				/>
			</div>
		</Card>
	);
}

SelectedUnitCard.propTypes = {
	unit: PropTypes.object
};
